import { defineMessages } from 'react-intl';
export default defineMessages({
  modalTitle: {
    id: "AddVismaSignModal.modalTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Add Visma digital signature"
    }]
  },
  signerEmail: {
    id: "AddVismaSignModal.signerEmail",
    defaultMessage: [{
      "type": 0,
      "value": "Signatory email"
    }]
  },
  addVismaSign: {
    id: "AddVismaSignModal.addVismaSign",
    defaultMessage: [{
      "type": 0,
      "value": "Send invitation to sign the certificate"
    }]
  },
  confirmTitle: {
    id: "AddVismaSignModal.confirmTitle",
    defaultMessage: [{
      "type": 0,
      "value": "This action is irreversible, please confirm that the signatory email is correct"
    }]
  },
  invitatationToSignWillBeSentTo: {
    id: "AddVismaSignModal.invitatationToSignWillBeSentTo",
    defaultMessage: [{
      "type": 0,
      "value": "Invitation to sign certificate will be sent to "
    }, {
      "type": 8,
      "value": "b",
      "children": [{
        "type": 1,
        "value": "signerEmail"
      }]
    }, {
      "type": 8,
      "value": "br",
      "children": []
    }, {
      "type": 0,
      "value": "Signatory will be able to use it during 90 days, if invitation have not been fulfilled, the process is cancelled"
    }]
  },
  saveLabel: {
    id: "General.saveLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Save"
    }]
  }
});